import { createModuleStore } from '../utils'
import { watch, computed } from 'vue'
import { log } from '@/services/log'

export function useImpinjReaderConfigsStore() {
  const storeFn = createModuleStore(
    'impinj-reader-configs',
    {
      type: 'Impinj Reader Config',
      pageHeading: 'Impinj Reader Configs',
      noHistory: true,
      sortingOn: 'toolbar',
      statusesFilterName: 'statuses',
      uploadOptionsCsv: '',
      uri: '/readers/configs/impinj',
      serviceUri: '/readers/configs/impinj',
      listingModuleName: 'Config',
      listingActivityName: 'View Impinj Reader Config',
      formModuleName: 'Config',
      toolsConfig: null,
      showToolsActivityModal: false,
      formActivityName: 'Edit Impinj Reader Config',
      allFields: [
        {
          key: 'name',
          title: 'NAME',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'session',
          title: 'SESSION',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'readerType',
          title: 'READER TYPE',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'gpiPort',
          title: 'GPI PORT',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'readerMode',
          title: 'READER MODE',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'enableLinkMonitorMode',
          title: 'ENABLED LINK MOINTOR MODE',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'externalId',
          title: 'UUID',
          visible: false,
          sortable: false,
          disabled: false,
        },
        {
          key: 'hubEnabled',
          title: 'HUB ENABLE',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'includeAntennaPortNumber',
          title: 'INCLUDE ANTENNA PORT NUMBER',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'includeChannel',
          title: 'INCLUDE CHANNEL',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'includeCrc',
          title: 'INCLUDE CRC',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'includeDopplerFrequency',
          title: 'INCLUDE DOPPLER FREQUENCY',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'includeFastId',
          title: 'INCLUDE FAST ID',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'includeFirstSeenTime',
          title: 'INCLUDE FIRST SEEN TIME',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'includeGpsCoordinates',
          title: 'INCLUDE GPS COORDINATES',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'includeLastSeenTime',
          title: 'INCLUDE LAST SEEN TIME',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'includePcBits',
          title: 'INCLUDE PC BITS',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'includePeakRssi',
          title: 'INCLUDE PEAK RSSI',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'includePhaseAngle',
          title: 'INCLUDE PHASE ANGLE',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'includeSeenCount',
          title: 'INCLUDE SEEN COUNT',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'keepAlivesEnabled',
          title: 'KEEP ALIVES ENABLED',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'keepAlivesPeriodMillis',
          title: 'KEEP ALIVES PERIOD (SECONDS)',
          type: 'millisToSecond',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'linkDownThreshold',
          title: 'LINK DOWN THRESHOLD',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'reportMode',
          title: 'REPORT MODE',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'searchMode',
          title: 'SEARCH MODE',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'useTls',
          title: 'USE TLS',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'tagPopulationEstimate',
          title: 'POPULATION ESTIMATE',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'autoStartPeriodMillis',
          title: 'AUTO START PERIOD (SECONDS)',
          type: 'millisToSecond',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'autoStopDurationMillis',
          title: 'AUTO STOP DURATION (SECONDS)',
          type: 'millisToSecond',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'createdBy',
          title: 'CREATED BY',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'createdTimestamp',
          title: 'CREATED TIME',
          type: 'datetime',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'lastModifiedBy',
          title: 'LAST MODIFIED BY',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'lastModifiedTimestamp',
          title: 'LAST MODIFIED TIME',
          type: 'datetime',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'status',
          title: 'STATUS',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'actions',
          title: 'ACTIONS',
          visible: true,
          disabled: true,
          sortable: false,
        },
      ],
    },
    {
      gpiEnabledLabel: 'GPI Disabled',
      hubEnabledLabel: 'Hub Disabled',
      allReaderOptions: [],
    },
    {
      readerOptionsUpdated(values) {
        log('In reader option selected in impinj store', values)
        store.allReaderOptions.forEach((opt) => {
          log('Resetting option:', opt.value)
          store.formData[opt.value] = false
        })
        store.formData['options'].forEach((selectedOpt) => {
          log('Setting option to true:', selectedOpt)
          store.formData[selectedOpt] = true
        })
      },
      resetPageFilters() {
        const store = storeFn()
        store.resetBaseFilters()
      },
      copy(item) {
        const obj = {
          session: item.session,
          readerType: item.readerType,
          gpiPort: item.gpiPort,
          reportMode: item.reportMode,
          readerMode: item.readerMode,
          searchMode: item.searchMode,
          tagPopulationEstimate: item.tagPopulationEstimate,
          gpiEnabled: item.gpiEnabled,
          autoStopDurationMillis: item.autoStopDurationMillis,
          autoStartPeriodMillis: item.autoStartPeriodMillis,
          enableLinkMonitorMode: item.enableLinkMonitorMode,
          linkDownThreshold: item.linkDownThreshold,
          keepAlivesEnabled: item.keepAlivesEnabled,
          keepAlivesPeriodMillis: item.keepAlivesPeriodMillis,
          includePhaseAngle: item.includePhaseAngle,
          includePeakRssi: item.includePeakRssi,
          includePcBits: item.includePcBits,
          includeGpsCoordinates: item.includeGpsCoordinates,
          includeDopplerFrequency: item.includeDopplerFrequency,
          includeChannel: item.includeChannel,
          includeSeenCount: item.includeSeenCount,
          includeFirstSeenTime: item.includeFirstSeenTime,
          includeLastSeenTime: item.includeLastSeenTime,
          includeAntennaPortNumber: item.includeAntennaPortNumber,
          useTls: item.useTls,
        }
        return obj
      },
    },
    {
      actionBindings: {
        options: 'readerOptionsUpdated',
      },
      fields: [
        {
          id: 'impinj_reader_reader_type',
          name: 'readerType',
          label: 'Reader Type',
          size: 4,
          component: 'NSelect',
          componentProps: { placeholder: 'Pick reader type' },
          rules: [
            {
              required: true,
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'impinj_reader_session',
          name: 'session',
          label: 'Session',
          size: 4,
          defaultValue: 2,
          component: 'NSelect',
          componentProps: { placeholder: 'Pick RFID session', optionsAlias: 'SearchModes' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'impinj_reader_default_report_mode',
          name: 'reportMode',
          label: 'Report Mode',
          size: 4,
          component: 'PickList',
          componentProps: { placeholder: 'Pick report mode', optionsAlias: 'ReportModes' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'impinj_reader_auto_start_period_millis',
          name: 'autoStartPeriodMillis',
          label: 'Auto start period',
          size: 4,
          visible: false,
          component: 'ArsTimeInput',
          defaultValue: 1000,
          componentProps: { placeholder: 'Enter auto start period' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'impinj_reader_auto_stop_duration_millis',
          name: 'autoStopDurationMillis',
          label: 'Auto stop duration',
          size: 4,
          visible: false,
          component: 'ArsTimeInput',
          defaultValue: 980,
          componentProps: { placeholder: 'Enter auto stop duration' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'impinj_reader_default_search_mode',
          name: 'searchMode',
          label: 'Search Mode',
          size: 4,
          component: 'PickList',
          componentProps: { placeholder: 'Pick search mode', optionsAlias: 'SearchModes' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'impinj_reader_default_reader_mode',
          name: 'readerMode',
          label: 'Reader Mode',
          size: 4,
          component: 'PickList',
          componentProps: { placeholder: 'Pick reader mode', optionsAlias: 'ReaderModes' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'impinj_reader_tag_population_estimate',
          name: 'tagPopulationEstimate',
          label: 'Tag Population',
          size: 4,
          component: 'NInputNumber',
          defaultValue: 8,
          componentProps: { placeholder: 'Enter tag population' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'impinj_reader_enable_link_monitor_mode',
          name: 'enableLinkMonitorMode',
          size: 4,
          component: 'NCheckbox',
          label: 'Enable Link Monitor Mode',
          componentProps: {},
          defaultValue: false,
          rules: [
            {
              required: true,
              type: 'boolean',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'impinj_reader_link_down_threshold',
          name: 'linkDownThreshold',
          label: 'Link Down Threshold',
          size: 4,
          component: 'NInputNumber',
          defaultValue: 5,
          componentProps: { placeholder: 'Enter link down threshold' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'impinj_reader_keep_alives_enabled',
          name: 'keepAlivesEnabled',
          size: 4,
          component: 'NCheckbox',
          defaultValue: false,
          label: 'Enable Keep Alives',
          componentProps: {},
          rules: [
            {
              required: true,
              type: 'boolean',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'impinj_reader_keep_alives_period_millis',
          name: 'keepAlivesPeriodMillis',
          label: 'Keep Alive Period',
          size: 6,
          component: 'ArsTimeInput',
          defaultValue: 60000,
          componentProps: { placeholder: 'Enter keep alive period', showAs: 'millis' },
          rules: [
            {
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'impinj_reader_api_enabled',
          name: 'gpiEnabled',
          size: 4,
          component: 'NCheckbox',
          templateLabel: 'gpiEnabledLabel',
          label: 'Enable GPI',
          defaultValue: false,
          componentProps: {},
          visible: false,
          rules: [
            {
              type: 'boolean',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'impinj_reader_gpi_port',
          name: 'gpiPort',
          label: 'GPI Port',
          size: 4,
          component: 'NInputNumber',
          visible: false,
          componentProps: { placeholder: 'Enter GPI port' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'impinj_reader_hub_enabled',
          name: 'hubEnabled',
          size: 4,
          visible: false,
          component: 'NCheckbox',
          templateLabel: 'hubEnabledLabel',
          label: 'Enable Antenna Hub',
          componentProps: {},
          rules: [
            {
              type: 'boolean',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'impinj_reader_options',
          name: 'options',
          label: 'Reader Options',
          size: 24,
          component: '',
          componentProps: {},
          rules: [
            {
              type: 'array',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'impinj_reader_config_name',
          name: 'name',
          label: 'Name',
          size: 24,
          component: 'NInput',
          componentProps: { placeholder: 'Enter descriptive name' },
          rules: [
            {
              required: true,
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'impinj_reader_include_phase_angle',
          name: 'includePhaseAngle',
          label: 'Include Phase Angle',
          size: 4,
          visible: false,
          defaultValue: false,
          componentProps: {},
        },
        {
          id: 'impinj_reader_include_peak_rssi',
          name: 'includePeakRssi',
          label: 'Include Peak Rssi',
          size: 4,
          visible: false,
          defaultValue: false,
          componentProps: {},
        },
        {
          id: 'impinj_reader_include_pc_bits',
          name: 'includePcBits',
          label: 'Include Pc Bits',
          size: 4,
          visible: false,
          defaultValue: false,
          componentProps: {},
        },
        {
          id: 'impinj_reader_include_gps_coordinates',
          name: 'includeGpsCoordinates',
          label: 'Include Gps Coordinates',
          size: 4,
          visible: false,
          defaultValue: false,
          componentProps: {},
        },
        {
          id: 'impinj_reader_include_doppler_frequency',
          name: 'includeDopplerFrequency',
          label: 'Include Doppler Frequency',
          size: 4,
          visible: false,
          defaultValue: false,
          componentProps: {},
        },
        {
          id: 'impinj_reader_include_channel',
          name: 'includeChannel',
          label: 'Include Channel',
          size: 4,
          visible: false,
          defaultValue: false,
          componentProps: {},
        },
        {
          id: 'impinj_reader_include_seen_count',
          name: 'includeSeenCount',
          label: 'Include Seen Count',
          size: 4,
          visible: false,
          defaultValue: true,
          componentProps: {},
        },
        {
          id: 'impinj_reader_include__first_seen_time',
          name: 'includeFirstSeenTime',
          label: 'Include First Seen Time',
          size: 4,
          visible: false,
          defaultValue: false,
          componentProps: {},
        },
        {
          id: 'impinj_reader_include_last_seen_time',
          name: 'includeLastSeenTime',
          label: 'Include Last Seen Time',
          size: 4,
          visible: false,
          defaultValue: false,
          componentProps: {},
        },
        {
          id: 'impinj_reader_include_antenna_port_number',
          name: 'includeAntennaPortNumber',
          label: 'Include Antenna Port Number',
          size: 4,
          visible: false,
          defaultValue: false,
          componentProps: {},
        },
        {
          id: 'impinj_config_use_tls',
          name: 'useTls',
          label: 'Use Tls',
          size: 4,
          visible: false,
          defaultValue: false,
          componentProps: {},
        },
      ],
    }
  )
  const store = storeFn()
  const rptMode = computed(() => store?.formData?.reportMode ?? 1)
  watch(
    rptMode,
    (mode) => {
      const isBatchAfterStop = +mode === 2
      const affectedFields = ['autoStartPeriodMillis', 'autoStopDurationMillis']
      store.form?.fields?.filter((d) => affectedFields.includes(d.name))?.forEach((d) => (d.visible = isBatchAfterStop))
    },
    { immediate: true }
  )
  const enableLinkMonitorMode = computed(() => store?.formData?.enableLinkMonitorMode ?? true)
  watch(
    enableLinkMonitorMode,
    (checked) =>
      store.form?.fields?.filter((d) => d.name === 'linkDownThreshold')?.forEach((d) => (d.visible = checked)),
    { immediate: true }
  )

  const enableGpi = computed(() => store?.formData?.gpiEnabled ?? true)
  watch(
    enableGpi,
    (checked) => {
      store.form?.fields?.filter((d) => d.name === 'gpiPort')?.forEach((d) => (d.visible = checked))
      store.form.gpiEnabledLabel = checked ? 'GPI Enabled' : 'GPI Disabled'
    },
    { immediate: true }
  )

  const enableHub = computed(() => store?.formData?.hubEnabled ?? true)
  watch(
    enableHub,
    (checked) => {
      store.form.hubEnabledLabel = checked ? 'Hub Enabled' : 'Hub Disabled'
    },
    { immediate: true }
  )
  const keepAlivesEnabled = computed(() => store?.formData?.keepAlivesEnabled ?? true)
  watch(
    keepAlivesEnabled,
    (checked) =>
      store.form?.fields?.filter((d) => d.name === 'keepAlivesPeriodMillis')?.forEach((d) => (d.visible = checked)),
    { immediate: true }
  )
  return store
}
